module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-LightItalic.af8e7e14.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-LightItalic.woff
// module id = 522
// module chunks = 0